<template>
  <config-base class="opc-lm-edit" ref="baseRef" :on="$listeners" @view-details="showPlanDetailDialog" show-plan-details
    :plan-details-label="$t('billing.delta.cur_plan_detail')">
    <template #config>
      <delta-edit-main :planType="planType" :title="title" />
      <preview-payment class="opc-lm-edit__preview-payment" />
    </template>
  </config-base>
</template>

<script>
import { mapGetters } from 'vuex';

import ConfigBase from '@/plans/LARGE_MEETING/config/base.vue';
import DeltaEditMain from '@/components/delta-edit-main.vue';
import PreviewPayment from '@/views/checkout/payment/preview-payment';
import ViewCurrentDialog from '@/components/view-current-dialog';

import mxPlanCommon from '@/plans/LARGE_MEETING/mixin';
import replenishMixin from '@/components/capacity/mx/replenish';
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';

export default {
  name: 'EditDelta',
  mixins: [mxPlanCommon, replenishMixin],
  data() {
    return {
      // ! note: the title in mxPlanCommon is replaced by replenishMixin
      title: this.$t('billing.large_meeting.title'),
      viewCurrentDialog: null,
    };
  },
  components: {
    ConfigBase,
    DeltaEditMain,
    PreviewPayment,
  },
  created() {
    this.viewCurrentDialog = new ServiceConfirm(ViewCurrentDialog);
  },
  methods: {
    showPlanDetailDialog() {
      this.viewCurrentDialog.confirm({
        planType: this.planType,
      });
    },
    showMessage(message) {
      this.msgInstance && this.msgInstance.close();
      this.msgInstance = this.$message({
        type: 'info',
        duration: 8000,
        message: message,
        showClose: true,
      });
    },
    mx_onAddedBasePlan(basePlanName) {
      this.showMessage(this.$t('billing.addon_auto_add_tips', [this.title, basePlanName]));
    },
    mx_onRemovedBasePlan(basePlanName) {
      this.showMessage(this.$t('billing.addon_auto_remove_tips', [this.title, basePlanName]));
    },
  },
  computed: {
    ...mapGetters(['getSelectedPlans']),
    selectedPlanList() {
      return this.getSelectedPlans;
    },
  },
};
</script>

<style lang="scss" scoped>
.opc-lm-edit {
  &__preview-payment {
    margin-top: 24px;
  }
}
</style>
